import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import classNames from 'classnames';
import Icon from '@icon/Icon';
import { FontAwesomeIconWrapper } from '@icon/fontawesome/FontAwesomeIconWrapper';
import { mediaValueName, mediaValueType } from './mediaLibrary';
// Glyph shown for anything that can't be rendered as a picture.
const TYPE_ICONS = {
    Image: ['fal', 'image'],
    Video: ['fal', 'file-video'],
    Audio: ['fal', 'file-audio'],
    Document: ['fal', 'file-alt'],
};
/**
 * @export
 * The one place that decides how a media value looks: an icon string renders
 * through `Icon`, a picture as a real `<img>`, everything else as a type glyph.
 *
 * Images deliberately go through `<img>` rather than `Icon` (which paints a
 * background image and so can't report a load failure) — an extensionless URL
 * is only *assumed* to be an image, and this is what makes that guess
 * self-correcting.
 *
 * Sizing is the caller's: the box fills its parent and icons/glyphs follow the
 * parent's `font-size`.
 */
const MediaThumb = (props) => {
    const { value, name, src, type, fit = 'cover' } = props;
    const [failed, setFailed] = React.useState(false);
    const source = src || value;
    // A new source deserves a fresh attempt at the picture.
    React.useEffect(() => setFailed(false), [source]);
    const resolved = type !== null && type !== void 0 ? type : mediaValueType(value);
    const label = name !== null && name !== void 0 ? name : mediaValueName(value);
    const showImage = resolved === 'Image' && !!source && !failed;
    return _jsx("div", { className: classNames('uxpcore_mediapicker__thumb', `uxpcore_mediapicker__thumb--${fit}`), children: resolved === 'Icon'
            ? _jsx(Icon, { icon: value })
            : showImage
                ? _jsx("img", { src: source, alt: label, loading: "lazy", onError: () => setFailed(true) })
                // A guessed picture that didn't load is some other file (e.g. a PDF behind an extensionless URL)
                : _jsx(FontAwesomeIconWrapper, { icon: (!failed && TYPE_ICONS[resolved]) || TYPE_ICONS.Document }) });
};
export default MediaThumb;
